import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilesLoaderComponent } from './files-loader/files-loader.component';
import { SelectedFile } from './selected-file.model';
import { Study } from './study.service';
import { UploadFormComponent } from './upload-form/upload-form.component';
import { Upload } from './upload.service';

@Component({
  selector: 'app-upload',
  template: `
  @if (entity?.id) {
    <app-files-loader [(files)]="files" [selectedStudy]="selectedStudy" [(entity)]="entity!" />
  } @else {
    <app-upload-form [(files)]="files" [(selectedStudy)]="selectedStudy" [(entity)]="entity" />
  }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilesLoaderComponent, UploadFormComponent]
})
export class UploadComponent {
  /**
   * Selected files.
   */
  protected files: SelectedFile[] = [];

  /**
   * Selected study.
   */
  protected selectedStudy!: Study;

  /**
   * Data upload.
   */
  protected entity?: Upload;
}
